import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import styles from './AudioGuidesList.css'
import AudioGuidesListItem from '../AudioGuidesListItem/AudioGuidesListItem';
import { getPathFromAbsoluteUrl } from '../../../services/service-utils'
import DonutSpinner from '../../DonutSpinner/DonutSpinner';

const AudioGuidesList = (props) => {

  const { items } = props.data
  const { currentRoute } = props
  const { language, colors, smk_guide: guide = {} } = currentRoute

  const [audioguides, setAudioguides] = useState(items || [])
  const [listItemsLoadedCount, setListItemsLoadedCount] = useState(0)

  const onListItemLoaded = () => {
    setListItemsLoadedCount(listItemsLoadedCount => listItemsLoadedCount + 1)
  }

  useEffect(() => { setAudioguides(items || []) }, items)

  return (
    <section className={styles.AudioGuidesList}>

      <div className="container-fluid">
        <div className="row">
          <div className="col-xs-12">
            {guide.link_help_page_url && (
              <Link to={getPathFromAbsoluteUrl(guide.link_help_page_url)} className={`${styles.help}`}>
                <div>
                  {guide.link_help_page_text}
                </div>
                <div className={styles.helpIcon}>
                  <div>?</div>
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>

      {(listItemsLoadedCount !== audioguides.length) && (
        <DonutSpinner colors={colors} />
      )}

      <div className={`${styles.itemsContainer}`} style={(listItemsLoadedCount === audioguides.length ? {} : { display: 'none' })}>
        {audioguides && audioguides.map((audioguide, index) => (
          <AudioGuidesListItem
            audioguide={audioguide}
            language={language}
            key={`agli-${index}`}
            onLoaded={onListItemLoaded}
            index={index}
          />
        ))}
      </div>

    </section>
  )
}

export default AudioGuidesList



// WEBPACK FOOTER //
// ./src/components/AudioGuideComponents/AudioGuidesList/AudioGuidesList.js